import { withApollo } from 'hoc/withApollo';
import AppLayout from 'containers/layouts/AppLayout';
import AgendaPageLayout from 'containers/layouts/agendaPage/AgendaPageLayout';
import React, { useEffect, useState } from 'react';
import Head from 'next/head';
import { useRouter } from 'next/router';
import FilterTutorial from '../components/tutorial/FilterTutorial';
import NotificationCTABanner from '../components/notifications/NotificationCTABanner';
import GuidedTourOverlay, { GuidedTourStep } from '../components/notifications/GuidedTourOverlay';

const Agenda = () => {
  const [tourOpen, setTourOpen] = useState(false);
  const router = useRouter();

  useEffect(() => {
    if (router.query.openTutorial === '1') {
      window.dispatchEvent(new Event('ouaaa:open-filters'));
      const t = setTimeout(() => {
        window.dispatchEvent(new Event('ouaaa:open-filter-tutorial'));
      }, 200);
      return () => clearTimeout(t);
    }
  }, [router.query.openTutorial]);

  const tourSteps: GuidedTourStep[] = [
    {
      target: '[data-tour="filter-panel"]',
      title: '1. Choisissez vos critères',
      body:
        "Sélectionnez ici les catégories, le lieu, le rayon ou la période qui vous intéressent. Le contenu se filtre en direct.",
      placement: 'right',
      onEnter: () => {
        window.dispatchEvent(new Event('ouaaa:open-filters'));
      },
      dimSelectors: [
        '[data-tour="invite-actor"]',
        '[data-tour="suggest-event"]',
      ],
    },
    {
      target: '[data-tour="save-filter"]',
      title: '2. Enregistrez votre filtre',
      body:
        "Cliquez sur « Enregistrer » pour conserver ce filtre. Il apparaîtra ensuite dans votre liste de filtres personnalisés.",
      placement: 'right',
    },
    {
      target: '[data-tour="notification-bell"]',
      title: "3. Activez les notifications",
      body:
        "Cliquez sur la cloche à côté de votre filtre pour recevoir un email ou une notification dans l'application à chaque nouveauté correspondante.",
      placement: 'right',
    },
  ];

  return (
    <AppLayout hideFooter={true}>
      <Head>
        <title>L&apos;agenda de la transition écologique et sociale en Aunis</title>
        <meta name="description" content="Les associations, entreprises, particuliers, services publics, collectifs et réseaux de la transition écologique et sociale en Aunis proposent toute l'année des évènements, rencontres, débats, manifestations, formations... Viens y participer !" />
      </Head>
      <NotificationCTABanner
        storageKey="agenda"
        title="Suivez les événements près de chez vous"
        body="3 étapes pour ne plus rien rater : filtrer, enregistrer, activer."
        onActivateNotifications={() => setTourOpen(true)}
      />
      <FilterTutorial onOpen={() => window.dispatchEvent(new Event('ouaaa:open-filters'))} />
      <AgendaPageLayout />
      <GuidedTourOverlay
        open={tourOpen}
        steps={tourSteps}
        onClose={() => setTourOpen(false)}
      />
    </AppLayout>
  );
};

export default withApollo()(Agenda);
